import { runtimeConfig } from './runtime-config';

const translations: Record<string, Record<string, string>> = {
    en: {
        code: 'Code',
        copyConfigLink: 'Copy link to configuration',
        copied: 'Copied',
        zoomIn: 'Zoom in',
        zoomOut: 'Zoom out',
        fullscreen: 'Fullscreen',
        snapshot: 'Snapshot',
        exportPlanningData: 'Export planning data',
        exportPdfDatasheet: 'Export PDF datasheet',
        shareUnavailable: 'Share link upload is not configured',
        shareFailed: 'The share link could not be created.',
        pdfUnavailable: 'The PDF export is not available in this environment.',
    },
    de: {
        code: 'Code',
        copyConfigLink: 'Konfigurationslink kopieren',
        copied: 'Kopiert',
        zoomIn: 'Heranzoomen',
        zoomOut: 'Herauszoomen',
        fullscreen: 'Vollbildansicht',
        snapshot: 'Schnappschuss',
        exportPlanningData: 'Planungsdaten exportieren',
        exportPdfDatasheet: 'Datenblatt PDF export',
        shareUnavailable: 'Der Share-Link-Upload ist nicht konfiguriert',
        shareFailed: 'Der Share-Link konnte nicht erstellt werden.',
        pdfUnavailable: 'Der PDF-Export ist in dieser Umgebung nicht verfügbar.',
    },
    fr: {
        code: 'Code',
        copyConfigLink: 'Copier le lien de configuration',
        copied: 'Copié',
        zoomIn: 'Zoomer',
        zoomOut: 'Dézoomer',
        fullscreen: 'Plein écran',
        snapshot: 'Capture',
        exportPlanningData: 'Exporter les données de planification',
        exportPdfDatasheet: 'Exporter la fiche PDF',
        shareUnavailable: 'Le partage n’est pas configuré',
        shareFailed: 'Le lien de partage n’a pas pu être créé.',
        pdfUnavailable: 'L’export PDF n’est pas disponible dans cet environnement.',
    }
};

export function getCurrentLanguage(): string {
    const language = runtimeConfig.bootstrapLanguage ?? localStorage.getItem('currentLanguage') ?? 'de';
    return translations[language] != null ? language : 'de';
}

export function translate(input: string, language: string): string {
    const dictionary = translations[language] ?? translations.de;
    return dictionary[input] ?? input;
}

export function translateLocalStorage(input: string): string {
    return translate(input, getCurrentLanguage());
}
